var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,37H16c-0.55,0-1-0.45-1-1V20c0-0.55,0.45-1,1-1h88c0.55,0,1,0.45,1,1v16C105,36.55,104.55,37,104,37z  M17,35h86V21H17V35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,49.9c-0.01-0.1-0.04-0.2-0.08-0.29l-6-14C104.76,35.24,104.4,35,104,35H16c-0.4,0-0.76,0.24-0.92,0.61 l-6,14C9.04,49.7,9.01,49.8,9,49.9l-6,50c-0.03,0.28,0.06,0.56,0.25,0.77C3.45,100.88,3.72,101,4,101h46h20h46 c0.28,0,0.55-0.12,0.74-0.33c0.19-0.21,0.28-0.49,0.25-0.77L111,49.9z M70.85,99H49.15H5.11l5.87-48.75L16.66,37h86.68 l5.68,13.25L114.89,99H70.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.04,65.39 7.8,63.82 17.55,56.09 24.8,35.66 26.68,36.33 19.25,57.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "110.96,65.39 100.75,57.3 93.32,36.33 95.2,35.66 102.45,56.09 112.2,63.82  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkirt);
export default __webpack_public_path__ + "static/media/skirt.01501557f34143743968b78eb8433cfb.svg";
export { ForwardRef as ReactComponent };